module.exports = __webpack_public_path__ + "img/notificationSettings.d6329c7a.svg";